<template>
    <div class="habilitation-section">
        <p class="habilitation-section__title"><strong>Representação</strong></p>

        <template v-if="isCompany">
            <p class="habilitation-section__hint">
                Pessoa jurídica precisa informar pelo menos um representante legal.
            </p>
            <div
                v-for="(representative, index) in form.legal"
                :key="`legal-${index}`"
                class="habilitation-section__card"
            >
                <div class="habilitation-section__card-head">
                    <strong
                        >Representante legal {{ form.legal.length > 1 ? index + 1 : '' }}</strong
                    >
                    <v-btn
                        v-if="form.legal.length > 1"
                        text
                        small
                        color="primary"
                        :disabled="disabled"
                        @click="form.legal.splice(index, 1)"
                        ><v-icon small left>mdi-delete-outline</v-icon> Remover</v-btn
                    >
                </div>
                <person-fields :person="representative" :disabled="disabled" with-registration />
                <v-file-input
                    v-model="representative.document"
                    label="Contrato social, estatuto, identidade ou CNH"
                    v-bind="fileProps"
                    class="mt-3"
                    :rules="requiredFile"
                />
            </div>
            <v-btn text color="primary" :disabled="disabled" @click="addLegal"
                ><v-icon left>mdi-plus</v-icon> Adicionar representante legal</v-btn
            >
        </template>

        <template v-if="isEstate">
            <div class="habilitation-section__card">
                <div class="habilitation-section__card-head"><strong>Inventariante</strong></div>
                <person-fields :person="form.inventory" :disabled="disabled" with-registration />
                <v-row>
                    <v-col cols="12" md="4">
                        <v-file-input
                            v-model="form.inventory.nomination"
                            label="Decisão de nomeação"
                            v-bind="fileProps"
                            class="mt-3"
                            :rules="requiredFile"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-file-input
                            v-model="form.inventory.acceptance"
                            label="Termo de aceite"
                            v-bind="fileProps"
                            class="mt-3"
                            :rules="requiredFile"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-file-input
                            v-model="form.inventory.identity"
                            label="Documento de identificação"
                            v-bind="fileProps"
                            class="mt-3"
                            :rules="requiredFile"
                        />
                    </v-col>
                </v-row>
            </div>
        </template>

        <p class="mb-1">Neste ato o credor está representado por advogado?</p>
        <v-radio-group
            v-model="form.hasLawyer"
            row
            :disabled="disabled"
            :rules="[(answer) => answer !== null || 'Campo obrigatório']"
            hide-details="auto"
            class="mt-0"
        >
            <v-radio label="Não" :value="false" />
            <v-radio label="Sim" :value="true" />
        </v-radio-group>

        <div v-if="form.hasLawyer" class="habilitation-section__card">
            <div class="habilitation-section__card-head"><strong>Advogado</strong></div>
            <person-fields :person="form.lawyer" :disabled="disabled" with-oab />
            <v-file-input
                v-model="form.lawyer.procuration"
                label="Procuração"
                v-bind="fileProps"
                class="mt-3"
                :rules="requiredFile"
            />
        </div>
    </div>
</template>

<script>
import { CREDITOR_PROFILE } from '@/common/creditor-profiles.data';
import PersonFields from './PersonFields.vue';

const emptyPerson = () => ({ name: '', registration: '', oab: '', email: '', phone_number: '' });

export const emptyRepresentation = () => ({
    hasLawyer: null,
    lawyer: { ...emptyPerson(), procuration: null },
    legal: [{ ...emptyPerson(), document: null }],
    inventory: { ...emptyPerson(), nomination: null, acceptance: null, identity: null }
});

export default {
    name: 'RepresentationSection',
    components: { PersonFields },
    props: {
        value: { type: Object, required: true },
        creditorType: { type: Number, default: null },
        disabled: { type: Boolean, default: false },
        maxFileSizeMb: { type: Number, default: 10 }
    },
    data() {
        return { form: this.value };
    },
    watch: {
        value(next) {
            this.form = next;
        }
    },
    computed: {
        isCompany() {
            return this.creditorType === CREDITOR_PROFILE.COMPANY;
        },
        isEstate() {
            return this.creditorType === CREDITOR_PROFILE.ESTATE;
        },
        fileProps() {
            return {
                accept: 'application/pdf, image/png, image/jpeg',
                prependIcon: '',
                prependInnerIcon: 'mdi-paperclip',
                disabled: this.disabled,
                showSize: true,
                outlined: true,
                dense: true,
                hideDetails: 'auto'
            };
        },
        requiredFile() {
            return [this.$rules.required, this.$rules.fileSize(this.maxFileSizeMb)];
        }
    },
    methods: {
        addLegal() {
            this.form.legal.push({ ...emptyPerson(), document: null });
        }
    }
};
</script>
